export default "__VITE_ASSET__bd11e77c__"